import { ScreenSize, detectScreenSize } from '@tda/utilities';
import { AppActionTypes, ApplicationActions } from '../store/application-actions';

export function hideHistory(dispatch: React.Dispatch<ApplicationActions>) {
  const screenSize = detectScreenSize();
  if (screenSize === ScreenSize.Small) {
    dispatch({ type: AppActionTypes.TOGGLE_HISTORY });
  }
}
